
import { CartItem } from "./CartItem";
import type { CartItem as CartItemType } from "@/context/CartContext";

interface CartItemsListProps {
  items: CartItemType[];
  onQuantityChange: (itemId: string, change: number) => void;
  onRemoveItem: (itemId: string) => void;
}

export const CartItemsList = ({ items, onQuantityChange, onRemoveItem }: CartItemsListProps) => {
  return (
    <div className="bg-white rounded-lg shadow-sm divide-y max-w-full overflow-hidden">
      {items.map((item) => (
        <CartItem
          key={`${item.id}-${item.variant.size}-${item.variant.colorName}`}
          item={item}
          onQuantityChange={onQuantityChange}
          onRemoveItem={onRemoveItem}
        />
      ))}
    </div>
  );
};
